import { IFinancialAccount } from '../store/payments/payments-interfaces-helper';
import { IContact } from '../store/contacts/contacts-interfaces';
import { IApplicationData } from '../store/merchnts/merchant-interfaces';

export interface ISender {
	relatedEntityType: string,
	relatedEntityId: string,
	relatedEntityDba: string,
	accountType: string,

}
export interface IBatchesData {
	adjustment: number;
	batchType: string;
	canPost: boolean;
	canUnpost: boolean;
	capturePeriodFrom: string;
	capturePeriodTo: string;
	chargebacks: number;
	chargebacksCount: number;
	currency: string;
	currencyCode: string;
	currencySymbol: string;
	flexChargeChargebackFeesAmount: number;
	flexChargeFees: number;
	flexChargeFeesCount: number;
	fundingChannel: string;
	id: string;
	isPosted: boolean;
	isShelved: boolean;
	merchantName?: string;
	mid?: string;
	payoutAmount?: number;
	payoutDate: string;
	payoutId?: string;
	receiver: ISender,
	reserveHold: number;
	reserveRelease: number;
	reserveUtilization: number;
	returns: number;
	returnsCount: number;
	scheduledFor?: string;
	status?: string;
	totalCount: number;
	totalValue: number;
	sender: ISender,
	comment: string;
	internalComment?: string;
}

export interface IPaginationData {
	firstItemOnPage: number;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	isFirstPage: boolean;
	isLastPage: boolean;
	lastItemOnPage: number;
	pageCount: number;
	pageNumber: number;
	pageSize: number;
	totalItemCount: number;
	isCountEstimated: boolean;
	rows: ISettlementsTableRowData[] | IFinancialAccount[] | IContact[] | IApplicationData[];
}

export interface ISettlementsTableRowData {
	adjustment?: number,
	batchType: string,
	capturePeriodFrom?: string,
	capturePeriodTo?: string,
	chargebacks?: number;
	currencyCode?: number,
	flexChargeFees?: number,
	flexChargeChargebackFeesAmount?: number,
	id?: string;
	mid?: string;
	currencySymbol?: string,
	currency?: string,
	paymentRef?: string;
	payoutAmount?: number;
	payoutDate?: string;
	receiver: ISender,
	reserveHold?: number;
	reserveRelease?: number;
	reserveUtilization?: number;
	returns?: number;
	totalValue?: number;
	sender: ISender,
	comment: string;
	internalComment?: string;
}

export interface IFormattedBatchesData {
	adjustment: number,
	batchType: string;
	canPost: boolean,
	canUnpost: boolean,
	capturePeriodFrom: string,
	capturePeriodTo: string,
	chargebacks: number,
	chargebacksCount: number,
	currency: string,
	currencyCode: string,
	currencySymbol: string,
	flexChargeChargebackFeesAmount: number,
	flexChargeFees: number,
	flexChargeFeesCount: number,
	fundingChannel: string,
	isPosted: boolean,
	isShelved: boolean,
	payoutAmount: number,
	payoutDate: string,
	payoutId: string,
	reserveHold: number,
	reserveRelease: number,
	reserveUtilization: number,
	returns: number,
	returnsCount: number,
	scheduledFor: string,
	status: string,
	totalCount: number,
	totalValue: number,
	senderRelatedEntityType: string,
	senderRelatedEntityId: string,
	senderRelatedEntityDba: string,
	senderAccountType: string,
	receiverRelatedEntityType: string,
	receiverRelatedEntityId: string,
	receiverRelatedEntityDba: string,
	receiverAccountType: string,
}

export const getFormattedBatchesData = (data: IBatchesData[]): IFormattedBatchesData[] => {
	return data?.map(el => ({
		adjustment: el?.adjustment,
		batchType: el?.batchType,
		canPost: el?.canPost,
		canUnpost: el?.canUnpost,
		capturePeriodFrom: el?.capturePeriodFrom,
		capturePeriodTo: el?.capturePeriodTo,
		chargebacks: el?.chargebacks,
		chargebacksCount: el?.chargebacksCount,
		currency: el?.currency,
		currencyCode: el?.currencyCode,
		currencySymbol: el?.currencySymbol,
		flexChargeChargebackFeesAmount: el?.flexChargeChargebackFeesAmount,
		flexChargeFees: el?.flexChargeFees,
		flexChargeFeesCount: el?.flexChargeFeesCount,
		fundingChannel: el?.fundingChannel,
		isPosted: el?.isPosted,
		isShelved: el?.isPosted,
		payoutAmount: el?.payoutAmount,
		payoutDate: el?.payoutDate,
		payoutId: el?.payoutId,
		reserveHold: el?.reserveHold,
		reserveRelease: el?.reserveRelease,
		reserveUtilization: el?.reserveUtilization,
		returns: el?.returns,
		returnsCount: el?.returnsCount,
		scheduledFor: el?.scheduledFor,
		status: el?.status,
		totalCount: el?.totalCount,
		totalValue: el?.totalValue,
		senderRelatedEntityType: el?.sender?.relatedEntityType,
		senderRelatedEntityId: el?.sender?.relatedEntityId,
		senderRelatedEntityDba: el?.sender?.relatedEntityDba,
		senderAccountType: el?.sender?.accountType,
		receiverRelatedEntityType: el?.receiver?.relatedEntityType,
		receiverRelatedEntityId: el?.receiver?.relatedEntityId,
		receiverRelatedEntityDba: el?.receiver?.relatedEntityDba,
		receiverAccountType: el?.receiver?.accountType,
		comment: el?.comment,
	}));
};

export interface IFormattedSettlementsData {
	adjustment?: number,
	batchType?: string;
	capturePeriodFrom?: string,
	capturePeriodTo?: string,
	chargebacks?: number;
	currencyCode?: number,
	currencySymbol?: string,
	currency?: string,
	flexChargeFees?: number,
	flexChargeChargebackFeesAmount?: number,
	id?: string;
	mid?: string;
	paymentRef?: string;
	payoutAmount?: number;
	payoutDate?: string;
	reserveHold?: number;
	reserveRelease?: number;
	reserveUtilization?: number;
	returns?: number;
	totalValue?: number;
	senderRelatedEntityType: string,
	senderRelatedEntityId: string,
	senderRelatedEntityDba: string,
	senderAccountType: string,
	receiverRelatedEntityType: string,
	receiverRelatedEntityId: string,
	receiverRelatedEntityDba: string,
	receiverAccountType: string,
}

export const getFormattedSettlementData = (data: ISettlementsTableRowData[]): IFormattedSettlementsData[] => {
	return data?.map(el => ({
		adjustment: el?.adjustment,
		batchType: el?.batchType,
		capturePeriodFrom: el?.capturePeriodFrom,
		capturePeriodTo: el?.capturePeriodTo,
		chargebacks: el?.chargebacks,
		currencyCode: el?.currencyCode,
		currencySymbol: el?.currencySymbol,
		currency: el?.currency,
		flexChargeFees: el?.flexChargeFees,
		flexChargeChargebackFeesAmount: el?.flexChargeChargebackFeesAmount,
		id: el?.id,
		paymentRef: el?.paymentRef,
		payoutAmount: el?.payoutAmount,
		payoutDate: el?.payoutDate,
		reserveHold: el?.reserveHold,
		reserveRelease: el?.reserveRelease,
		reserveUtilization: el?.reserveUtilization,
		returns: el?.returns,
		totalValue: el?.totalValue,
		senderRelatedEntityType: el?.sender?.relatedEntityType,
		senderRelatedEntityId: el?.sender?.relatedEntityId,
		senderRelatedEntityDba: el?.sender?.relatedEntityDba,
		senderAccountType: el?.sender?.accountType,
		receiverRelatedEntityType: el?.receiver?.relatedEntityType,
		receiverRelatedEntityId: el?.receiver?.relatedEntityId,
		receiverRelatedEntityDba: el?.receiver?.relatedEntityDba,
		receiverAccountType: el?.receiver?.accountType,
	}));
};
